<form class="numeric-field-container" ui-form [formGroup]="validateForm">
  <ui-form-item class="form-item">
    <ui-form-label class="field-label" uiFor="unit" [uiNoColon]="true">{{ "unit" | localize }}</ui-form-label>
    <ui-form-control class="field-input">
      <ui-select formControlName="unit">
        <ui-option *ngFor="let option of unitList" [uiValue]="option.unit" [uiLabel]="option.display"></ui-option>
        <ui-option [uiValue]="'custom'" [uiLabel]="'+ custom'"></ui-option>
        <ui-option *ngIf="customUnit" [uiValue]="customUnit" [uiLabel]="customUnit"></ui-option>
      </ui-select>
    </ui-form-control>
  </ui-form-item>
  <ui-form-item class="form-item">
    <ui-form-label class="field-label" uiFor="fractionSize" [uiNoColon]="true">{{ "decimal_places" | localize }}</ui-form-label>
    <ui-form-control class="field-input" uiErrorTip="We have error">
      <ui-select formControlName="fractionSize">
        <ui-option *ngFor="let opt of fractionSizeList" class="fraction-size-option" [uiValue]="opt.value" [uiLabel]="opt.display" [uiCustomContent]="opt.customContent">
          <div class="fraction-size-value">{{ opt.value }}</div>
          <div class="fraction-size-example">{{ opt.example }}</div>
        </ui-option>
      </ui-select>
    </ui-form-control>
  </ui-form-item>
</form>
